<section
  *ngxPermissionsOnly="Permission.TICKETING_WRITE"
  class="flex items-center justify-between bg-white px-6 py-5 text-black"
  aria-labelledby="billing-help-heading"
  aria-describedby="billing-help-description"
>
  <div>
    <h2 id="billing-help-heading" class="text-lg font-semibold">
      Have a question about your bill?
    </h2>
    <p id="billing-help-description" class="mt-0.5 text-sm">
      Reach out to our support team for assistance.
    </p>
  </div>
  <button
    type="button"
    (click)="onCreateTicket()"
    class="btn-primary"
    aria-label="Create a Ticket for billing support"
  >
    Create a Ticket
  </button>
</section>
